import { AddressType } from '@lmc/ts-common'

/**
 * Main permanent residence–only fields must not be persisted on other address types.
 * Sends empty strings so the payload explicitly clears any previously stored values on the backend.
 */
export function sanitizeAddressesForResidentUpdate<
  T extends {
    type?: number | null
    accommodationDetails?: string | null
    dateOfObservation?: string | null
  }
>(addresses: T[] | undefined | null): T[] | undefined {
  if (addresses == null) {
    return undefined
  }
  return addresses.map((addr) => {
    if (!addr) {
      return addr
    }
    if (addr.type !== AddressType.Main_Permanent_Residence) {
      return {
        ...addr,
        accommodationDetails: '',
        dateOfObservation: ''
      }
    }
    return addr
  })
}
